/** Extrae mensaje legible de errores Axios / Laravel en mutaciones de rentabilidad. */
export function getProfitabilityMutationErrorMessage(error: unknown, fallback: string): string {
  const err = error as {
    response?: { data?: { message?: string; errors?: Record<string, string[] | string> } };
    message?: string;
  };
  const data = err.response?.data;
  if (data?.message && typeof data.message === 'string') return data.message;
  const errors = data?.errors;
  if (errors && typeof errors === 'object') {
    for (const key of Object.keys(errors)) {
      const v = errors[key];
      if (Array.isArray(v) && v[0]) return String(v[0]);
      if (typeof v === 'string') return v;
    }
  }
  if (err.message) return err.message;
  return fallback;
}

/**
 * Errores típicos al importar Excel en servidor (p. ej. simplexml sobre documento vacío / archivo corrupto).
 * Devuelve `friendlyMessage` si el texto crudo coincide; si no, el mensaje resuelto por la API.
 */
export function getProfitabilityAdImportErrorMessage(
  error: unknown,
  fallback: string,
  friendlyCorruptFile: string
): string {
  const raw = getProfitabilityMutationErrorMessage(error, fallback);
  const lower = raw.toLowerCase();
  if (
    lower.includes('simplexml') ||
    (lower.includes('parser error') && lower.includes('document is empty')) ||
    lower.includes('document is empty')
  ) {
    return friendlyCorruptFile;
  }
  return raw;
}
